import type { RouterLocation } from "@vaadin/router";

export interface RouterAndLocale {
  payor: string;
  locale: string;
}

export function getStore(search: string): string {
  const parameters = new URLSearchParams(search || window.location.search);
  const store = parameters.get("store");

  if (store === null) {
    return "";
  }

  return `?store=${store}`;
}

export function getPayorAndLocale(location: RouterLocation): RouterAndLocale {
  const parameters = location.params;

  const payor = Array.isArray(parameters.payor)
    ? parameters.payor[0]
    : parameters.payor;

  const locale = Array.isArray(parameters.locale)
    ? parameters.locale[0]
    : parameters.locale;

  if (payor === undefined || locale === undefined) {
    throw new Error("payor / and or locale are missing from the route");
  }

  return { payor, locale };
}

export function getSearch(location: RouterLocation): string {
  return location.search || window.location.search;
}

export function getRoute(location: RouterLocation): string | undefined {
  const foundRoute = location.routes.find(
    (route) => route.component !== "web-kiosk"
  )?.path;

  if (foundRoute === undefined || foundRoute === "") {
    return undefined;
  }

  return foundRoute;
}
